const rNonAlphanumericOrHyphen = /[^a-zA-Z0-9-]/g;

export function slugify(str) {
  return str
    .replace(/æ/g, "ae")
    .replace(/ø/g, "oe")
    .replace(/å/g, "aa")
    .replace(/Æ/g, "AE")
    .replace(/Ø/g, "OE")
    .replace(/Å/g, "AA")
    .replace(/\s+/g, "-")
    .replace(rNonAlphanumericOrHyphen, "")
    .toLowerCase();
}

export function uniqueSlug(slug) {
  let candidate = slug;
  let counter = 2;
  while (document.getElementById(candidate)) {
    candidate = `${slug}-${counter}`;
    counter++;
  }
  return candidate;
}
